export function createStorage(key) {
  return {
    get: function get() {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    set: function set(data) {
      var json = JSON.stringify(data);
      window.localStorage.setItem(key, json);
    },
    remove: function remove() {
      window.localStorage.removeItem(key);
    }
  };
}